import React from 'react';
import Card from '@material-ui/core/Card';
import CardHeader from '@material-ui/core/CardHeader';
import { withStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import ViewComfy from '@material-ui/icons/ViewComfy';
import CardContent from '@material-ui/core/CardContent';
import Button from '@material-ui/core/Button';
import CardActions from '@material-ui/core/CardActions';
import Snackbar from '@material-ui/core/Snackbar';
import CloudUploadIcon from '@material-ui/icons/CloudUpload';
import Chip from '@material-ui/core/Chip';
import { PDF_TYPES } from '../../helpers/constants/productAttachmentTypes';
import CheckBoxComp from '../CheckBoxComp';
import { pdfs } from '../../reducers/pdfs';

const pdfsFormStyles = {
  button: {
    margin: 12,
  },
  image: {
  },
  exampleImageInput: {
    cursor: 'pointer',
    position: 'absolute',
    top: 0,
    bottom: 0,
    right: 0,
    left: 0,
    width: '100%',
    opacity: 0,
  },
};

const PdfsForm = (props) => {
  const {classes, pdfs} = props;

  const pdfOne = pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_ONE).length ?
    pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_ONE)[0].attachment.name : undefined;

  const pdfTwo = pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_TWO).length ?
    pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_TWO)[0].attachment.name : undefined;

  const pdfThree = pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_THREE).length ?
    pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_THREE)[0].attachment.name : undefined;

  const pdfFour = pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_FOUR).length ?
    pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_FOUR)[0].attachment.name : undefined;


  const pdfFive = pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_FIVE).length ?
    pdfs.filter(pdf => pdf.pdfType === PDF_TYPES.PDF_FRONTPAGE_FIVE)[0].attachment.name : undefined;

  const canUpload = !props.pdfs ||
    (props.pdfs && (!pdfOne && !pdfTwo && !pdfThree && !pdfFour && !pdfFive));

  return (
    <div className="col-md-12">
      <Card>
        <CardHeader
          avatar={
            <IconButton>
              <ViewComfy/>
            </IconButton>
          }
          title="Administer Pdfs"
        />
        <CardContent>
          <div className="col col-lg-4 offset-lg-3">
            <form id="form-Pdf" className="form-horizontal" onSubmit={props.handleSubmit}>
              <Button variant="contained" color="default" className={classes.button}>
                Pdf 1
                <CloudUploadIcon className={classes.rightIcon} />
                <input
                  type="file"
                  accept="application/pdf"
                  onChange={(evt) =>
                    props.handlePdfInput(evt, PDF_TYPES.PDF_FRONTPAGE_ONE)}
                  style={{
                    cursor: 'pointer',
                    position: 'absolute',
                    top: 0,
                    bottom: 0,
                    right: 0,
                    left: 0,
                    width: '100%',
                    opacity: 0,
                  }}
                />
              </Button>
              {
                pdfOne ?
                  <Chip
                    label={pdfOne}
                    onDelete={() => props.removePdf(PDF_TYPES.PDF_FRONTPAGE_ONE)}
                  />
                  :
                  null
              }
              <div
                style={{
                  marginLeft: 20,
                }}
              >
              <CheckBoxComp
                Checked={props.isPublic[PDF_TYPES.PDF_FRONTPAGE_ONE]}
                Type="checkbox"
                Name="isPublicOne"
                Label="Is public?" PropHandleInputChange={(name, checked) => {
                props.handleIsPublic({pdf:PDF_TYPES.PDF_FRONTPAGE_ONE, checked})
              }}
              />
              </div>
              <div>
                <Button variant="contained" color="default" className={classes.button}>
                  Pdf 2
                  <CloudUploadIcon className={classes.rightIcon} />
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(evt) =>
                      props.handlePdfInput(evt, PDF_TYPES.PDF_FRONTPAGE_TWO)}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                      left: 0,
                      width: '100%',
                      opacity: 0,
                    }}
                  />
                </Button>
                {
                  pdfTwo ?
                    <Chip
                      label={pdfTwo}
                      onDelete={() => props.removePdf(PDF_TYPES.PDF_FRONTPAGE_TWO)}
                    />
                    :
                    null
                }
                <div
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <CheckBoxComp
                    Checked={props.isPublic[PDF_TYPES.PDF_FRONTPAGE_TWO]}
                    Type="checkbox"
                    Name="isPublicTwo"
                    Label="Is public?" PropHandleInputChange={(name, checked) => {
                    props.handleIsPublic({pdf:PDF_TYPES.PDF_FRONTPAGE_TWO, checked})
                  }}
                  />
                </div>
              </div>
              <div>
                <Button variant="contained" color="default" className={classes.button}>
                  Pdf 3
                  <CloudUploadIcon className={classes.rightIcon} />
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(evt) =>
                      props.handlePdfInput(evt, PDF_TYPES.PDF_FRONTPAGE_THREE)}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                      left: 0,
                      width: '100%',
                      opacity: 0,
                    }}
                  />
                </Button>
                {
                  pdfThree ?
                    <Chip
                      label={pdfThree}
                      onDelete={() => props.removePdf(PDF_TYPES.PDF_FRONTPAGE_THREE)}
                    />
                    :
                    null
                }
                <div
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <CheckBoxComp
                    Checked={props.isPublic[PDF_TYPES.PDF_FRONTPAGE_THREE]}
                    Type="checkbox"
                    Name="isPublicThree"
                    Label="Is public?" PropHandleInputChange={(name, checked) => {
                    props.handleIsPublic({pdf:PDF_TYPES.PDF_FRONTPAGE_THREE, checked})
                  }}
                  />
                </div>
              </div>
              <div>
                <Button variant="contained" color="default" className={classes.button}>
                  Pdf 4
                  <CloudUploadIcon className={classes.rightIcon} />
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(evt) =>
                      props.handlePdfInput(evt, PDF_TYPES.PDF_FRONTPAGE_FOUR)}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                      left: 0,
                      width: '100%',
                      opacity: 0,
                    }}
                  />
                </Button>
                {
                  pdfFour ?
                    <Chip
                      label={pdfFour}
                      onDelete={() => props.removePdf(PDF_TYPES.PDF_FRONTPAGE_FOUR)}
                    />
                    :
                    null
                }
                <div
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <CheckBoxComp
                    Checked={props.isPublic[PDF_TYPES.PDF_FRONTPAGE_FOUR]}
                    Type="checkbox"
                    Name="isPublicFour"
                    Label="Is public?" PropHandleInputChange={(name, checked) => {
                    props.handleIsPublic({pdf:PDF_TYPES.PDF_FRONTPAGE_FOUR, checked})
                  }}
                  />
                </div>
              </div>
              <div>
                <Button variant="contained" color="default" className={classes.button}>
                  Pdf 5
                  <CloudUploadIcon className={classes.rightIcon} />
                  <input
                    type="file"
                    accept="application/pdf"
                    onChange={(evt) =>
                      props.handlePdfInput(evt, PDF_TYPES.PDF_FRONTPAGE_FIVE)}
                    style={{
                      cursor: 'pointer',
                      position: 'absolute',
                      top: 0,
                      bottom: 0,
                      right: 0,
                      left: 0,
                      width: '100%',
                      opacity: 0,
                    }}
                  />
                </Button>
                {
                  pdfFive ?
                    <Chip
                      label={pdfFive}
                      onDelete={() => props.removePdf(PDF_TYPES.PDF_FRONTPAGE_FIVE)}
                    />
                    :
                    null
                }
                <div
                  style={{
                    marginLeft: 20,
                  }}
                >
                  <CheckBoxComp
                    Checked={props.isPublic[PDF_TYPES.PDF_FRONTPAGE_FIVE]}
                    Type="checkbox"
                    Name="isPublicFive"
                    Label="Is public?" PropHandleInputChange={(name, checked) => {
                    props.handleIsPublic({pdf:PDF_TYPES.PDF_FRONTPAGE_FIVE, checked})
                  }}
                  />
                </div>
              </div>
            </form>
          </div>
          <CardActions>
            <Button
              disabled={canUpload}
              color="primary"
              variant="contained"
              form="form-Pdf"
              type="submit">Save</Button>
          </CardActions>
        </CardContent>
      </Card>
      <Snackbar
        open={props.formWarningOpen}
        message={props.formWarningOpen}
        autoHideDuration={6000}
      />
    </div>
  );
};

PdfsForm.defaultProps = {};

export default withStyles(pdfsFormStyles, { withTheme: true })(PdfsForm);



// WEBPACK FOOTER //
// ./src/components/Pdfs/pdfsForm.js